<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-lines-orders-emit',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },

  computed: {
    ...mapGetters([
      'isShowItemCodeLinesEmit',
      'isShowItemCodeSellerLinesEmit',
      'isShowItemCodeBuyerLinesEmit',
      'isShowGtin14CodeLinesEmit',
      'isShowCentroEntregaLinesEmit',
      'isShowDescriptionLinesEmit',
      'isShowStatusLinesEmit',
      'isShowQuantityLinesEmit',
      'isShowMeasureLinesEmit',
      'isShowUnitOfMeasureTradeUnitLinesEmit',
      'isShowNetPriceLinesEmit',
      'isShowGrossPriceLinesEmit',
      'isShowCurrencyLinesEmit',
      'isShowTotalAmountLinesEmit',
      'isShowDeliveryDateFromLinesEmit',
      'isShowDeliveryDateToLinesEmit',
      'isShowQuantityTradeUnitLinesEmit',
      'isShowQuantityRemainingEmit'
    ])
  },

  methods: {
    ...mapActions([
      'isShowItemCodeLinesEmitAction',
      'isShowItemCodeSellerLinesEmitAction',
      'isShowItemCodeBuyerLinesEmitAction',
      'isShowGtin14CodeLinesEmitAction',
      'isShowCentroEntregaLinesEmitAction',
      'isShowDescriptionLinesEmitAction',
      'isShowStatusLinesEmitAction',
      'isShowQuantityLinesEmitAction',
      'isShowMeasureLinesEmitAction',
      'isShowUnitOfMeasureTradeUnitLinesEmitAction',
      'isShowNetPriceLinesEmitAction',
      'isShowGrossPriceLinesEmitAction',
      'isShowCurrencyLinesEmitAction',
      'isShowTotalAmountLinesEmitAction',
      'isShowDeliveryDateFromLinesEmitAction',
      'isShowDeliveryDateToLinesEmitAction',
      'isShowQuantityTradeUnitLinesEmitAction',
      'isShowQuantityRemainingEmitAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'itemCode':
          isShow = !this.isShowItemCodeLinesEmit
          this.isShowItemCodeLinesEmitAction(isShow)
          break
        case 'itemCodeSeller':
          isShow = !this.isShowItemCodeSellerLinesEmit
          this.isShowItemCodeSellerLinesEmitAction(isShow)
          break
        case 'itemCodeBuyer':
          isShow = !this.isShowItemCodeBuyerLinesEmit
          this.isShowItemCodeBuyerLinesEmitAction(isShow)
          break
        case 'gtin14Code':
          isShow = !this.isShowGtin14CodeLinesEmit
          this.isShowGtin14CodeLinesEmitAction(isShow)
          break
        case 'centreDeliveryPoint':
          isShow = !this.isShowCentroEntregaLinesEmit
          this.isShowCentroEntregaLinesEmitAction(isShow)
          break
        case 'description':
          isShow = !this.isShowDescriptionLinesEmit
          this.isShowDescriptionLinesEmitAction(isShow)
          break
        case 'status':
          isShow = !this.isShowStatusLinesEmit
          this.isShowStatusLinesEmitAction(isShow)
          break
        case 'quantity':
          isShow = !this.isShowQuantityLinesEmit
          this.isShowQuantityLinesEmitAction(isShow)
          break
        case 'measure':
          isShow = !this.isShowMeasureLinesEmit
          this.isShowMeasureLinesEmitAction(isShow)
          break
        case 'quantityTradeUnit':
          isShow = !this.isShowQuantityTradeUnitLinesEmit
          this.isShowQuantityTradeUnitLinesEmitAction(isShow)
          break
        case 'unitOfMeasureTradeUnit':
          isShow = !this.isShowUnitOfMeasureTradeUnitLinesEmit
          this.isShowUnitOfMeasureTradeUnitLinesEmitAction(isShow)
          break
        case 'quantityRemaining':
          isShow = !this.isShowQuantityRemainingEmit
          this.isShowQuantityRemainingEmitAction(isShow)
          break
        case 'netPrice':
          isShow = !this.isShowNetPriceLinesEmit
          this.isShowNetPriceLinesEmitAction(isShow)
          break
        case 'grossPrice':
          isShow = !this.isShowGrossPriceLinesEmit
          this.isShowGrossPriceLinesEmitAction(isShow)
          break
        case 'currency':
          isShow = !this.isShowCurrencyLinesEmit
          this.isShowCurrencyLinesEmitAction(isShow)
          break
        case 'totalAmount':
          isShow = !this.isShowTotalAmountLinesEmit
          this.isShowTotalAmountLinesEmitAction(isShow)
          break
        case 'deliveryDateFrom':
          isShow = !this.isShowDeliveryDateFromLinesEmit
          this.isShowDeliveryDateFromLinesEmitAction(isShow)
          break
        case 'deliveryDateTo':
          isShow = !this.isShowDeliveryDateToLinesEmit
          this.isShowDeliveryDateToLinesEmitAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('order.order_entity_table_detail.itemCode'), value: 'itemCode', show: this.isShowItemCodeLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.itemCodeSeller'), value: 'itemCodeSeller', show: this.isShowItemCodeSellerLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.itemCodeBuyer'), value: 'itemCodeBuyer', show: this.isShowItemCodeBuyerLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.gtin14Code'), value: 'gtin14Code', show: this.isShowGtin14CodeLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.description'), value: 'description', show: this.isShowDescriptionLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.quantity'), value: 'quantity', show: this.isShowQuantityLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.measure'), value: 'measure', show: this.isShowMeasureLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.quantityTradeUnit'), value: 'quantityTradeUnit', show: this.isShowQuantityTradeUnitLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.measureTradeUnit'), value: 'unitOfMeasureTradeUnit', show: this.isShowUnitOfMeasureTradeUnitLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.quantityRemaining'), value: 'quantityRemaining', show: this.isShowQuantityRemainingEmit
        }, {
          text: this.$t('order.order_entity_table_detail.netPrice'), value: 'netPrice', show: this.isShowNetPriceLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.grossPrice'), value: 'grossPrice', show: this.isShowGrossPriceLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.currency'), value: 'currency', show: this.isShowCurrencyLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.totalAmount'), value: 'totalAmount', show: this.isShowTotalAmountLinesEmit
        }, {
          text: this.$t('order.order_entity_table.delivery_date_from'), value: 'deliveryDateFrom', show: this.isShowDeliveryDateFromLinesEmit
        }, {
          text: this.$t('order.order_entity_table.delivery_date_to'), value: 'deliveryDateTo', show: this.isShowDeliveryDateToLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.status'), value: 'status', show: this.isShowStatusLinesEmit
        }, {
          text: this.$t('order.order_entity_table_detail.delivery_centre'), value: 'centreDeliveryPoint', show: this.isShowCentroEntregaLinesEmit
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
